const clearAuthData = () => localStorage.removeItem('token');

const setAuthData = (token: string) => localStorage.setItem('token', token);

const getAuthData = (): string => localStorage.getItem('token') || '';

export { clearAuthData, setAuthData, getAuthData };
